"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tagTester = _interopRequireDefault(require("./_tagTester.js"));
var _stringTagBug = require("./_stringTagBug.js");
var _methodFingerprint = require("./_methodFingerprint.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = _stringTagBug.isIE11 ? (0, _methodFingerprint.ie11fingerprint)(_methodFingerprint.setMethods) : (0, _tagTester.default)('Set');